import "css/search-results.sass";
import "css/search-results.css";
import "css/standard-cards.sass";
import $ from "jquery";

$(document).ready(function () {
  $(".dropdown-cb-search-class").each(function () {
    $(this).prop("selectedIndex", -1);
    var width = "185px";
    $(this).CreateMultiCheckBox({
      width: width,
      defaultText: $(this).attr("name"),
      height: "1000px",
    });
  });
});

$(document).ready(function () {
  $(document).on("click", ".multi-check-box", function () {
    var detail = $(this).next();
    if (detail.is(":visible")) {
      detail.hide();
    } else {
      detail.show();
    }
  });

  $(".search-results-pagination").each(function () {
    $(this).click(function (e) {
      var key_val = $(this).attr("part").split("=");
      var key = key_val[0];
      var val = key_val[1];
      var queryParams = new URLSearchParams(window.location.search);
      queryParams.set(key, val);
      var new_query = encodeURI("?" + queryParams.toString());
      history.replaceState(null, null, new_query);
    });
  });

  $(document).on("click", ".multi-check-box-detail-header input", function (e) {
    e.stopPropagation();
    var hc = $(this).prop("checked");
    $(this)
      .closest(".multi-check-box-detail")
      .find(".multi-check-box-detail-body input")
      .prop("checked", hc);
    $(this).closest(".multi-check-box-detail").next().UpdateSelect();
  });

  $(document).on("click", ".multi-check-box-detail-header", function (e) {
    var inp = $(this).find("input");
    var chk = inp.prop("checked");
    inp.prop("checked", !chk);
    $(this)
      .closest(".multi-check-box-detail")
      .find(".multi-check-box-detail-body input")
      .prop("checked", !chk);
    $(this).closest(".multi-check-box-detail").next().UpdateSelect();
  });

  $(document).on("click", ".multi-check-box-detail .cont input", function (e) {
    e.stopPropagation();
    $(this).closest(".multi-check-box-detail").next().UpdateSelect();

    var val =
      $(".multi-check-box-detail-body input:checked").length ==
      $(".multi-check-box-detail-body input").length;
    $(".multi-check-box-detail-header input").prop("checked", val);
  });

  $(document).on("click", ".multi-check-box-detail .cont", function (e) {
    var multiCheckBoxDetail = $(this).closest(".multi-check-box-detail");
    multiCheckBoxDetail.next().UpdateSelect();

    var val =
      $(".multi-check-box-detail-body input:checked").length ==
      $(".multi-check-box-detail-body input").length;
    $(".multi-check-box-detail-header input").prop("checked", val);
  });

  /* We don't need this event handler
             *
            $(document).mouseup(function (e) {
                var container = $(".multi-check-box-detail");
                if (!container.is(e.target) && container.has(e.target).length === 0) {
                    container.hide();
                }
            });
            */

  $(".mulinput").each(function () {
    $(this).change(function (evt) {
      $("#search-form").submit();
    });
  });
});

var defaultMultiCheckBoxOption = {
  width: "220px",
  defaultText: "Select Below",
  height: "200px",
};

// jQuery.fn.extend({
$.fn.extend({
  CreateMultiCheckBox: function (options) {
    var localOption = {};
    localOption.width =
      options != null && options.width != null && options.width != undefined
        ? options.width
        : defaultMultiCheckBoxOption.width;
    localOption.defaultText =
      options != null &&
      options.defaultText != null &&
      options.defaultText != undefined
        ? options.defaultText
        : defaultMultiCheckBoxOption.defaultText;
    localOption.height =
      options != null && options.height != null && options.height != undefined
        ? options.height
        : defaultMultiCheckBoxOption.height;

    this.hide();
    var klass_disabled = this[0].disabled ? " ft-ct-disabled" : "";
    this.attr("multiple", true);
    var divSel = $(
      "<div class='multi-check-box" +
        klass_disabled +
        "'>" +
        localOption.defaultText +
        "<span class='k-icon k-i-arrow-60-down'><svg aria-hidden='true' focusable='false' data-prefix='fas' data-icon='sort-down' role='img' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 512' class='svg-inline--fa fa-sort-down fa-w-10 fa-2x'><path fill='currentColor' d='M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z' class=''></path></svg></span></div>",
    ).insertBefore(this);
    divSel.css({ width: localOption.width });

    var detail = $(
      "<div class='multi-check-box-detail'><div class='multi-check-box-detail-body'></div></div>",
    ).insertAfter(divSel);
    detail.css({
      width: parseInt(options.width),
      "max-height": localOption.height,
    });
    var multiCheckBoxDetailBody = detail.find(".multi-check-box-detail-body");

    this.find("option").each(function () {
      var val = $(this).attr("value");
      var id = $(this).attr("id");
      var id_type = id.slice(-2);
      if (val !== "") {
        var display =
          $(this).css("display") == "block" ? "flex" : $(this).css("display");
        var checked = $(this).hasClass("o-selected") ? " checked" : "";
        var name = undefined;
        if (id_type === "_c") {
          name = "c" + val;
        } else if (id_type === "_f") {
          name = "f" + val;
        } else if (id_type === "_t") {
          name = "t" + val;
        }

        if (val == undefined) val = "";

        multiCheckBoxDetailBody.append(
          "<div class='cont' style='display: " +
            display +
            ";'><div><input name='" +
            name +
            "' id='" +
            id +
            "' type='checkbox' class='mulinput' value='" +
            val +
            "'" +
            checked +
            " style='margin-left: 0.3rem; margin-top: 0.1rem;' /></div><div class='ml-1' style='width: 100%'><label style='width: 100%' for='" +
            id +
            "'>" +
            $(this).text() +
            "</label></div></div>",
        );
      }
    });

    multiCheckBoxDetailBody.css(
      "max-height",
      parseInt($(".multi-check-box-detail").css("max-height")) - 28 + "px",
    );
  },
  UpdateSelect: function () {
    var arr = [];

    this.prev()
      .find(".mulinput:checked")
      .each(function () {
        arr.push($(this).val());
      });

    this.val(arr);
  },
});
